import { render, staticRenderFns } from "./AdminCommentsItem.vue?vue&type=template&id=208c57b6&"
import script from "./AdminCommentsItem.vue?vue&type=script&lang=js&"
export * from "./AdminCommentsItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommentsItem.vue?vue&type=style&index=0&id=208c57b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports